export default "__VITE_ASSET__CyZIRoFt__"